import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  TaskInfoService,
  CommonService,
  SessionService,
} from '@biz2x/libraries/core-utils/utils';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';
import { get } from 'lodash';
import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';

import * as AppStateActions from './app-state.actions';
import { UTIL_TASKS } from './app-state.models';
import { of } from 'rxjs';
import { dispatchActivityLog } from '@biz2x/libraries/core-utils/utils';

@Injectable()
export class AppStateEffects {
  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppStateActions.init),
      fetch({
        run: () => {
          /**
           * 1. Check if sessionId is available in localStorage
           * 2. If yes,
           *      get session id from localstorage
           *      fire a call to get-user using session id
           *      build the state
           *    If no,
           *      get user data from localstorage
           *      build the state
           */

          const sessionId = this.commonService.getDataFromStorage(
            'token',
            localStorage
          );
          const user = this.commonService.getDataFromStorage(
            'user',
            localStorage
          );
          if (sessionId) {
            return AppStateActions.setUserSession({
              id: sessionId,
              user: user,
            });
          }
          return AppStateActions.setUserSession({
            id: null, // ! Manually set null to trigger unauthorization
            user: {},
          });
        },
        onError: (action, errorData) => {
          return AppStateActions.setUserSession({
            id: null,
            user: {},
          });
        },
      })
    )
  );

  handleSignout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppStateActions.signOut),
      fetch({
        run: () => {
          const sessionId = this.commonService.getDataFromStorage(
            'token',
            localStorage
          );
          const payload = {
            'Content-Type': 'application/json',
            'x-session-id': sessionId,
          };
          return this.tasksService
            .saveTaskInfo({ slug: 'logout' }, payload)
            .pipe(
              map(() => {
                return AppStateActions.signOutSuccess();
              })
            );
        },
        onError: () => {
          return AppStateActions.signOutSuccess();
        },
      })
    )
  );

  bridgeActivityLog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(dispatchActivityLog),
      map(({ id, actions, payload }) => AppStateActions.utilApiTrigger({ id, actions, payload }))
    )
  );

    utilApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppStateActions.utilApiTrigger),
      // debounceTime(1000), 
      switchMap(({ id, actions, payload = {} }) => {
        const user = this.commonService.getDataFromStorage('admin_user', localStorage);
        const { id: user_id, partner_id } = user || {};

        const filteredActions =  id !== -1 ? actions : 
        actions.filter(({ old_value, new_value }) => ( new_value !== old_value))
        .map(({ action_id, new_value, old_value }) => ({ action_id, new_value, old_value }));


        const apiPayload = {
          template_id:(payload?.template_id || null),
          widget_id:(payload?.widget_id || null),
          user_email:(payload?.email || null),
          user_id: user_id ?? null,
          partner_id: partner_id ?? null,
          actions: filteredActions
        };

        const code = id === -1 ? 'Bulk Colour Change Trigger' : UTIL_TASKS[id];
        if (!filteredActions.length) {
          return of(
            AppStateActions.utilApiFailure({
              id,
              code,
              error: 'No Actionable Changes',
              apiPayload
            })
          );
        }
        return this.tasksService.sendActivityLogs(apiPayload).pipe(
          map(response =>
            AppStateActions.utilApiSuccess({ id, code, response, apiPayload })
          ),
          catchError(error => {
            console.error('Activity log API error:', error);
            return of(
              AppStateActions.utilApiFailure({ id, code, error, apiPayload })
            );
          })
        );
      })
    )
  );


  constructor(
    private readonly actions$: Actions,
    private readonly commonService: CommonService,
    private readonly sessionService: SessionService,
    private readonly tasksService: TaskInfoService
  ) {}
}